var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"section"},[_c('div',{staticClass:"main"},[_c('div',{staticClass:"header"},[_c('h1',[_vm._v("Brands & partners we're working with")])])])])
}]

export { render, staticRenderFns }